// Golf Match Play Tracker 2026 -- Constants

export const SEASON = "2026";

// ---------------------------------------------------------------------
// Divisions (4 divisions x 8 players = 32)
// ---------------------------------------------------------------------
export const DIVISIONS = ["Woods", "Nicklaus", "Palmer", "Hogan"];

export const DIVISION_COLORS = {
  Woods:    { bg: "bg-red-50",    border: "border-red-200",    text: "text-red-800",    dot: "bg-red-500" },
  Nicklaus: { bg: "bg-amber-50",  border: "border-amber-200",  text: "text-amber-800",  dot: "bg-amber-500" },
  Palmer:   { bg: "bg-sky-50",    border: "border-sky-200",    text: "text-sky-800",    dot: "bg-sky-500" },
  Hogan:    { bg: "bg-emerald-50",border: "border-emerald-200",text: "text-emerald-800",dot: "bg-emerald-500" },
};

export const PLAYERS_PER_DIVISION = 8;
export const REGULAR_SEASON_ROUNDS = 7;   // 8-player round robin => 7 rounds
export const PLAYOFF_QUALIFIERS_PER_DIVISION = 4;

// ---------------------------------------------------------------------
// Scoring
//   win     = 5
//   tie     = 3
//   loss    = 1
//   forfeit = 0 to the player who forfeits; the opponent receives 3
// ---------------------------------------------------------------------
export const RESULT_OPTIONS = ["pending", "win", "tie", "loss", "forfeit"];

export const POINTS = {
  win: 5,
  tie: 3,
  loss: 1,
  forfeit: 0,
  pending: 0,
};

// Points awarded to the player whose OPPONENT forfeited.
export const POINTS_OPPONENT_OF_FORFEIT = 3;

export const RESULT_LABELS = {
  pending: "Pending",
  tie: "Tie",
  win: "Win",
  loss: "Loss",
  forfeit: "Forfeit",
};

// ---------------------------------------------------------------------
// Tiebreakers (in order) -- see utils/scoring.js
//   1. Head-to-head result
//   2. Most wins
//   3. Most combined points from wins & ties only
//   4. 40yd dash / chip-off  (recorded manually by the admin)
// ---------------------------------------------------------------------
export const TIEBREAKER_LABELS = {
  points: "Total points",
  h2h: "Head-to-head",
  wins: "Most wins",
  winTiePoints: "Win+Tie points",
  manual: "Chip-off / 40yd dash",
  unresolved: "UNRESOLVED - chip-off required",
};

export const TIEBREAK_METHODS = [
  { value: "chip_off",        label: "Chip-off (chip + putt)" },
  { value: "chip_off_round2", label: "Chip-off round 2 (closest chip)" },
  { value: "dash_40yd",       label: "40 yard dash - 1st fairway" },
  { value: "other",           label: "Other" },
];

// ---------------------------------------------------------------------
// Tee time preference
//
// A player who cannot get away early declares "late" and the scheduler
// pushes their whole foursome to the back of the day. Everyone else is
// "early", which is the default -- a player with nothing set is treated
// as early, so an empty column never changes the schedule.
//
// Note this is a preference at the FOURSOME level: a group holds two
// matches (4 players), so one late player sends the entire group late.
// ---------------------------------------------------------------------
export const TEE_TIME_PREFERENCES = ["early", "late"];
export const DEFAULT_TEE_TIME_PREFERENCE = "early";

export const TEE_TIME_PREFERENCE_LABELS = {
  early: "Early",
  late: "Late",
};

// ---------------------------------------------------------------------
// Misc
// ---------------------------------------------------------------------
export const NINES = [
  { value: "F9", label: "Front 9" },
  { value: "B9", label: "Back 9" },
];

export const TODAY = new Date().toISOString().slice(0, 10);

export const GHIN_CREDENTIALS_KEY = "golf_tracker_2026_ghin_credentials";
export const ADMIN_SESSION_KEY = "golf_tracker_2026_admin";

// GHIN API master switch. Left OFF for 2026: handicaps, tee sets and
// course ratings are maintained in the Courses / Roster tabs. Flip to
// true (and set GHIN credentials) to sync from GHIN instead.
export const GHIN_API_ENABLED = false;
